import styled from 'styled-components'

import { helpers } from 'styles'

export const Label = styled.p`
	margin-top: 16px;
	margin-bottom: 4px;
	font-size: ${helpers.font.size.small};
`
